function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dom-helpers/node_modules/@babel/runtime/helpers/interopRequireDefault.js
// module id = 30
// module chunks = 0